'use client';
// This file was heavily inspired by Reach UI, Carbon Design System, and Chakra UI
// https://github.com/reach/reach-ui/blob/86a046f54d53b6420e392b3fa56dd991d9d4e458/packages/auto-id/src/index.ts
// https://github.com/carbon-design-system/carbon/blob/master/packages/react/src/internal/useId.js
// https://github.com/chakra-ui/chakra-ui/blob/main/packages/hooks/src/use-id.ts
//
//
import { useEffect, useLayoutEffect, useState } from 'react';
function canUseDOM() {
    return Boolean(typeof window !== 'undefined' &&
        typeof window.document !== 'undefined' &&
        window.document.createElement);
}
let id = 0, serverHandoffCompleted = false;
const generateId = () => {
    id += 1;
    return id;
};
const useIsomorphicLayoutEffect = canUseDOM() ? useLayoutEffect : useEffect;
export function useId(
/**
 * the external id passed from the user
 * */
idProp, 
/**
 * prefix to append before the id
 * */
prefix) {
    const initialId = idProp || (serverHandoffCompleted ? generateId() : null);
    const [uid, setUid] = useState(initialId);
    useIsomorphicLayoutEffect(() => {
        if (uid === null) {
            setUid(generateId());
        }
    }, []);
    useEffect(() => {
        if (serverHandoffCompleted === false) {
            serverHandoffCompleted = true;
        }
    }, []);
    const generatedId = uid !== null ? uid.toString() : undefined;
    // FIXME: should not return undefined
    return prefix ? `${prefix}-${generatedId}` : generatedId;
}
/*
* React hook to generate ids for use in compound components
*
* ```js
* const [buttonId, menuId] = useIds("52", "button", "menu")
*
* // buttonId will be `button-52`
* // menuId will be `menu-52`
* ```
*/
export function useIds(
/**
 * the external id passed from the user
 * */
idProp, 
/**
 * list of prefixes to use
 * */
...prefixes) {
    const generatedId = useId(idProp);
    return prefixes.map((prefix) => `${prefix}-${generatedId}`);
}
